module.exports = __webpack_public_path__ + "static/img/govcard_white_03.44758c2b.svg";